import enviroment from './enviroment'

class Host {
  public get (): string {
    if (enviroment === 'development') {
      return 'http://localhost:9301/v2'
    }

    if (enviroment === 'staging') {
      return 'https://dev.community-playlist.com/v2'
    }

    return 'https://www.community-playlist.com/v2'
  }
}

export default new Host().get()
